import moment from 'moment'
import firedux from '../firedux'
import {dispatch} from '../store'

import {
  MESSAGES_ENDPOINT
} from '../../config/constants'

import setNewMessage from '../actions/set_new_message'
import setNewNotification from '../actions/set_new_notification'
import getUser from '../getters/user'

let messageRef

const setNewMessageNotification = (message, options) => {
  const notification = {
    title: 'New Message',
    body: message.message
  }

  dispatch(setNewNotification(notification, options))
}

let onReceiveNewMessage = (containerId, notificationOptions, snapshot) => {
  if (snapshot.exists()) {
    const message = snapshot.val()

    dispatch(setNewMessage(message, snapshot.key(), containerId))
    getUser(message.from)
    if (notificationOptions) setNewMessageNotification(message, notificationOptions)
  }
}

let boundOnReceiveNewMessage = onReceiveNewMessage

export const watchNewMessages = (containerId, notificationOptions = null, startTime = moment().valueOf()) => {
  if (!containerId) return

  const ENDPOINT = `${MESSAGES_ENDPOINT}/${containerId}`

  boundOnReceiveNewMessage = onReceiveNewMessage.bind(null, containerId, notificationOptions)
  //messageRef = messageRef.bind(null, ENDPOINT, startTime)
  messageRef = firedux.ref.child(ENDPOINT).orderByChild('time').startAt(startTime)

  messageRef.on('child_added', boundOnReceiveNewMessage)
  messageRef.on('child_changed', boundOnReceiveNewMessage)
}

export const unwatchNewMessages = () => {
  if (!messageRef) return

  // TODO: find a way to correctly off this bound function
  messageRef.off('child_added', boundOnReceiveNewMessage)
  messageRef.off('child_changed', boundOnReceiveNewMessage)
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/watchers/new_messages.js
 **/